export default function Pulse({ color }: { color?: string }) {
  return (
    <div className="absolute flex items-center justify-center">
      <div
        className={
          "absolute h-4 w-4 rounded-full animate-[circle-pulse_1.5s_ease-out_infinite] " +
          (color ? color : "bg-primary-bg")
        }
      ></div>

      <div className="h-4 w-4 rounded-full"></div>
    </div>
  );
}
